import Player from "@vimeo/player";

class VimeoHeroVideo {
    constructor(el) {
        this.iframe = el;

        this.vimeoPlayer = null;
        this.videoHidden = false;

        this.playPause = document.getElementById("play-pause-btn");
        this.pauseIcon = document.getElementById("hero-video-pause-icon");
        this.playIcon = document.getElementById("hero-video-play-icon");
        this.heroVimeoContainer = document.querySelector(
            "[data-vimeo-container]",
        );

        //this.unMuteBtn = document.getElementById("unmute-btn");

        this.isMobile = window.matchMedia("(max-width: 576px)").matches;
        this.isReducedMotion = this.getReducedMotion();

        document.addEventListener("accessibilitySettingsChanged", (e) => {
            this.isReducedMotion = e.detail.reducedMotion;

            if (this.isReducedMotion) {
                this.heroVimeoContainer.classList.remove("is-visible");
                this.heroVimeoContainer.style.display = "none";

                this.vimeoPlayer.pause();
            }
        });

        this.handleVideo();
    }

    handleVideo() {
        this.vimeoPlayer = new Player(this.iframe);

        const featuredImage = document.querySelector(
            "[data-hero-feature-image]",
        );

        if (this.isMobile || this.isReducedMotion) {
            // Hide video container on load.
            this.heroVimeoContainer.classList.remove("is-visible");
            this.heroVimeoContainer.style.display = "none";

            this.vimeoPlayer.pause();

            // Pause icon visible.
            this.playIcon.hidden = false;
            this.pauseIcon.hidden = true;
            this.videoHidden = true;
        }

        this.handlePlayPause();

        // this.handleUnmuteMute(this.vimeoPlayer);
    }

    handlePlayPause() {
        if (!this.vimeoPlayer) {
            return;
        }

        this.playPause?.addEventListener("click", (e) => {
            const _this = this;

            this.vimeoPlayer
                .getPaused()
                .then(function (paused) {
                    if (paused) {
                        _this.play();
                    } else {
                        _this.pause();
                    }
                })
                .catch(function (error) {
                    console.error("Error toggling play/pause", error);
                });
        });
    }

    play() {
        this.vimeoPlayer.play();
        this.playIcon.hidden = true;
        this.pauseIcon.hidden = false;

        if (this.videoHidden) {
            this.heroVimeoContainer.classList.add("is-visible");
            this.this.heroVimeoContainer.style.display = "";
            this.videoHidden = false;
        }
    }

    pause() {
        this.vimeoPlayer.pause();
        this.playIcon.hidden = false;
        this.pauseIcon.hidden = true;
    }

    getReducedMotion() {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return true;
        }

        const stored = localStorage.getItem("accessibilitySettingsV1");

        if (stored) {
            const settings = JSON.parse(stored);

            console.log("reducedMotion", settings.reducedMotion);

            return settings.reducedMotion;
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const vimeoIframe = document.querySelector("[data-vimeo-container] iframe");

    if (vimeoIframe) {
        new VimeoHeroVideo(vimeoIframe);
    }
});

export default VimeoHeroVideo;
